// extracted by mini-css-extract-plugin
module.exports = {"dataFromLabel":"DataBy_dataFromLabel__299oT","dataFromIcon":"DataBy_dataFromIcon__VVxr3"};